import styled from "styled-components";
import Icon from "../Icon";
import { Text } from "../Text";

interface TimelineScrollPromptProps {}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Round = styled.div`
  position: relative;
  height: 64px;
  width: 64px;
  background-color: ${({ theme }) => theme.colors.hotPink};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TimelineScrollPrompt: React.FC<TimelineScrollPromptProps> = ({
  children,
}) => {
  return (
    <Wrapper>
      <Round>
        <Icon icon="height" />
      </Round>
      <Text>Scroll to begin</Text>
    </Wrapper>
  );
};
